import React from 'react';
import {array, func, string} from 'prop-types';

import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const filter = createFilterOptions();
function isString(str) {
  return typeof str === 'string';
}

export default function AutocompleteCreate({label, source, value, error, onChange, ...otherProps}) {
  return (
    <Autocomplete
      {...otherProps}
      value={value}
      onChange={(event, newValue) => {
        if (isString(newValue)) {
          onChange(newValue);
        } else if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          onChange(newValue.inputValue);
        } else {
          onChange(newValue);
        }
      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        // Suggest the creation of a new value
        if (params.inputValue !== '') {
          filtered.push({
            inputValue: params.inputValue,
            label: `Add "${params.inputValue}"`,
          });
        }
        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id={`autocomplete-create-${label}`}
      options={source}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (isString(option)) {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option;
      }}
      renderOption={(option) => isString(option) ? option : option.label}
      freeSolo
      fullWidth
      renderInput={(params) => (
        <TextField {...params} label={label} error={error} required />
      )}
    />
  );
}

AutocompleteCreate.propTypes = {
  label: string,
  source: array,
  value: string,
  onChange: func
}
